var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
let DraftLoadingScene = class DraftLoadingScene extends React.PureComponent {
    render() {
        return (React.createElement("div", { style: { flex: '1 1 auto', display: 'flex', alignItems: 'center', justifyContent: 'center' } },
            React.createElement("div", { style: { flex: '0 1 auto' } },
                React.createElement("div", { className: "lds-spinner" },
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null),
                    React.createElement("div", null)))));
    }
};
DraftLoadingScene = __decorate([
    observer
], DraftLoadingScene);
export { DraftLoadingScene };
